export default __webpack_public_path__ + "static/media/order_completion.dfc17b6c.png";